import {FC, useMemo} from "react";
import {CreateResult, CreateResultSummary} from "../../view-model";
import {summarizeResult} from "../../helpers";
import {usePlan} from "../../context";
import {SummaryCard} from "../common";
import {OrganizationDetailsCard} from "./OrganizationDetailsCard";
import "../common/BuilderStep.scss";

export interface ResultsStepProps {
  result: CreateResult;
}

export const ResultsStep: FC<ResultsStepProps> = ({result}) => {
  const {plan} = usePlan();
  const summary = useMemo<CreateResultSummary>(
    () => summarizeResult(plan.source, result),
    [plan.source, result]
  );

  const hasExistingTenant = !!plan.newEntity.tenantId;

  const tenantBaseLabelKey =
    result.status === "in-progress"
      ? "create-organization.plan-summary"
      : "create-organization.result-summary";

  const tenantQualifier =
    result.status === "in-progress"
      ? hasExistingTenant
        ? "existing-tenant"
        : "new-tenant"
      : hasExistingTenant
        ? "tenant-assigned"
        : "tenant-created";

  const tenantCount =
    result.status === "in-progress" ? 1 : result.status === "created" ? 1 : 0;

  return (
    <section
      id={"results-step"}
      data-testid={"results-step"}
      className={"organization-builder-step results-step"}>
      <section
        id={"summary-section"}
        data-testid={"summary-section"}
        className={"summary-section"}>
        <SummaryCard
          baseLabelKey={"create-organization.result-summary"}
          qualifier={"created"}
          count={summary.created ? 1 : 0}
        />
        <SummaryCard
          baseLabelKey={tenantBaseLabelKey}
          qualifier={tenantQualifier}
          count={tenantCount}
          name={plan.source.hierarchy?.custName ?? ""}
        />
      </section>
      <section
        id={"organization-section"}
        data-testid={"organization-section"}
        className={"organization-section"}>
        <OrganizationDetailsCard result={result} plan={plan} />
      </section>
    </section>
  );
};
